
import { supabase } from "@/integrations/supabase/client";
import { Purchase } from "@/models/purchase";
import { toast } from "@/components/ui/use-toast";

/**
 * Service for managing user purchases
 */
export const PurchaseService = {
  /**
   * Get all agents purchased by a user
   */
  async getPurchasedAgents(userId: string): Promise<any[]> {
    try {
      const { data, error } = await supabase
        .from('user_agents' as any)
        .select(`
          *,
          agents (
            id,
            name,
            description,
            category,
            pricing_model
          )
        `)
        .eq('user_id', userId);
      
      if (error) {
        console.error("Failed to fetch purchased agents:", error);
        throw error;
      }
      
      return data || [];
    } catch (error) {
      console.error("Failed to fetch purchased agents:", error);
      toast({
        title: "Error",
        description: "Failed to load your purchased agents. Please try again.",
        variant: "destructive",
      });
      return [];
    }
  },
  
  /**
   * Check if user has already purchased an agent
   */
  async hasPurchasedAgent(userId: string, agentId: string): Promise<boolean> {
    try {
      const { data, error } = await supabase
        .from('user_agents' as any)
        .select('id')
        .eq('user_id', userId)
        .eq('agent_id', agentId)
        .maybeSingle();
      
      if (error) {
        console.error("Error checking purchase status:", error);
        return false;
      }
      
      return !!data;
    } catch (error) {
      console.error("Failed to check purchase status:", error);
      return false;
    }
  }
};
